/**
 * created by lei lei
 *西工大文字按钮
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class TextBtn extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let btnText = this.props.btnText;
        let select = btnText=="选用";
        let abandon = btnText=="弃用";

        return (
                <div  style={{
                    fontSize: 14,
                    fontWeight: 400,
                    color: select?"#fff":'#0050B3',
                    fontFamily: 'Microsoft YaHei',
                    marginLeft:17, cursor: 'pointer',
                    padding:select||abandon?"4px":"",
                    borderRadius:select||abandon?"2px":"",
                    background:select?"rgba(0, 80, 179,.7)":abandon?"rgba(0, 80, 179,.3)":"",


                }} onClick={() => {
                    this.props.btnClick && this.props.btnClick()
                }}>{btnText}</div>

        )
    }

}